module.exports = __webpack_public_path__ + "img/headerSearch.7992f409.svg";